import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { batteryModel } from '../model/index';

@Injectable()
export class BatteryService {
    private headers = new Headers({
       'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'

        //'Content-Type': 'application/x-www-form-urlencoded charset=UTF-8', 'Accept': 'q=0.8;application/json;q=0.9'
    });
    private batteryUrl = 'api/battery';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getBatteryList(query: any): Promise<batteryModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.batteryUrl}/getBatteryList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }


    deleteBattery(battery_id: any): Promise<batteryModel> {
        const url = `${this.batteryUrl}/deleteBattery`;
        return this.http
            .post(url, $.param({ battery_id: battery_id }), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as batteryModel)
            .catch(this.handleError);
    }

    addUpdateBattery(batteryData: any): Promise<batteryModel> {

        const url = `${this.batteryUrl}/addUpdateBattery`;

        return this.http
            .post(url, $.param(batteryData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as batteryModel)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/battery.service.ts